<template>
    <div data-cy="container_cat_slider">
        <div class="flex items-center justify-start overflow-y-auto select-none font-medium text-12" data-cy="slider_category_tabs">
            <div class="flex-shrink-0 p-1"
                atm="category"
                :class="{'pl-4' : k == 0}"
                :data-cy="`item_category_tab_${k}`"
                v-for="(cat, k) in catList"
                :key="k">
                <div class="flex items-center justify-center gap-1.5 text-center px-4 py-3 cursor-pointer rounded-md  bg-a-blue-f2f5ff text-a-blue-2140a6"
                    v-if="k == activeIndex"
                    data-cy="btn_category_tab_active">
                    <div>
                        <img class="w-4" :src="cat.imageActive" data-cy="img_category_icon" />
                    </div>
                    <div class="leading-none" data-cy="text_category_name">{{catName(cat)}}</div>
                </div>
                <div class="flex items-center justify-center gap-1.5 text-center px-4 py-3 cursor-pointer rounded-md bg-white text-a-gray-a4a4a4 border border-a-blue-f2f5ff"
                     v-else
                     :data-cy="`btn_category_tab_${k}`"
                     @click="clickTab(k)">
                     <div>
                        <img class="w-4" :src="cat.imageInactive" data-cy="img_category_icon" />
                    </div>
                    <div class="leading-none" data-cy="text_category_name">{{catName(cat)}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: 'CatSlider',
    mixins: [LocaleMixin],
    props: {
        catList: { type: Array, required: true },
    },
    data: function() {
        return {
            activeIndex: 0,
            slide: {
                isDown: false,
                startX: 0,
                scrollLeft: 0,
            },
        };
    },
    created: function() {
        this.setDefaultTab();
    },
    methods: {
        setDefaultTab: function() {
            let catId = this.$route.params.catId;

            if (!Util.isEmptyStr(catId)) {
                for (let i in this.catList) {
                    if (this.catList[i].id == catId) {
                        this.activeIndex = i;
                        break;
                    }
                }
            }
        },
        catName: function(cat) {
            return this.localeCode == 1033 ? cat.nameEn : cat.nameTh;
        },
        clickTab: function(index) {
            this.activeIndex = index;
            let send = {
                index: index,
                cat: this.catList[index],
            };
            this.$emit('clickTab', send);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
